module.exports = __webpack_public_path__ + "img/my-device.a7baacf9.png";